<template>
  <div class="register-info-page">
    <div class="infoPage w1200">
      <div class="back" @click="back">&lt;返回</div>
      <div class="infobox">
        <div class="title">
          企业注册详情
          <span>提交时间：{{ time }}</span>
        </div>
        <div class="infoText">
          <el-descriptions class="margin-top"  :column="2" size="medium">
            <el-descriptions-item :label="item.label" v-for="(item,index) in companyInfo" :key="item.key">{{item.value}}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="failbox">
          <div class="lt">
            <img src="@/assets/img/003.png" alt />
          </div>
          <div class="rt">
            <div class="title">您的企业注册申请已提交 预计1-3个工作日审核完成</div>
            <ul>
              <li>
                <div class="dian"></div>
                支持中国大陆的企业、政府和组织进行注册
              </li>
              <li>
                <div class="dian"></div>
                协会提供安全、严格的真实性注册，也能更好地保护企业及用户的合法权益
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/layout/Foot/Foot.vue';
import { FindOrg, InternationalAreaCode } from '@/common/api.js';
import { filterByKey } from '@/common/utils.js';
export default {
  components: {
    Foot
  },
  data() {
    return {
      // 提交时间
      time: '',
      // 公司信息
      companyInfo: [
        {
          key: 'companyName',
          label: '企业或组织名称',
          value: ''
        },
        {
          key: 'orgNumber',
          label: '统一社会信用代码',
          value: ''
        },
        {
          key: 'person',
          label: '企业联系人姓名',
          value: ''
        },
        {
          key: 'personMobile',
          label: '联系人电话',
          value: ''
        },
        {
          key: 'personMail',
          label: '联系人邮箱',
          value: ''
        },
        {
          key: 'officialWebsite',
          label: '企业官网',
          value: ''
        },
        {
          key: 'certifiedProducts',
          label: '拟申请碳足迹认证的产品',
          value: ''
        },
        {
          key: 'address',
          label: '企业地址',
          value: ''
        },
        {
          key: 'business',
          label: '企业主营业务简介',
          value: ''
        }
      ],
      //
      areaCode: [],
      //
      orgTypeList: [],
      // 时间格式化
      df: new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    };
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 返回
    back() {
      this.$router.back();
    },
    // 获取信息
    getInfo() {
      this.getMcode().then((flag) => {
        if (flag) {
          FindOrg().then((res) => {
            if (res.success) {
              this.time = this.df.format(new Date(res.data.createTime));
              this.companyInfo.forEach((item) => {
                if (item.key == 'establishTime') {
                  item.value = res.data[item.key].split('T')[0];
                } else if (item.key == 'legalPersonMobile') {
                  let value = filterByKey('itemCode', res.data.phoneAreaCode, this.areaCode, 'itemName');
                  item.value = value + ' ' + res.data[item.key];
                } else if (item.key == 'orgType') {
                  item.value = filterByKey('itemCode', res.data.orgType, this.orgTypeList, 'itemName');
                } else {
                  item.value = res.data[item.key];
                }
              });
            }
          });
        } else {
          Message.error('数据获取失败');
        }
      });
    },
    //
    getMcode() {
      return InternationalAreaCode({ setCode: ['ORG_AUTH_INTERNATIONAL_AREA_CODE', 'ORG_TYPE'] }).then((res) => {
        if (res.success) {
          this.areaCode.push(...res.data.ORG_AUTH_INTERNATIONAL_AREA_CODE);
          this.orgTypeList.push(...res.data.ORG_TYPE);
          return true;
        } else {
          this.$message.error(res.message);
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-descriptions-item {
    padding-bottom: 20px !important;
  }
}
.register-info-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.infoPage {
  padding-bottom: 50px;
  img {
    display: inline-block;
  }
  .infobox {
    width: 850px;
    margin: 0 auto;
    margin-top: 24px;
  }
  .back {
    font-size: 16px;
    height: 68px;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  .title {
    display: flex;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    color: var(--color-text-1);
    margin-bottom: 24px;
    span {
      font-size: 14px;
      color: var(--color-text-3);
      line-height: 20px;
      margin-left: auto;
    }
  }
  .infoText {
    box-sizing: border-box;
    width: 844px;
    background: url('~@/assets/img/rzjz.png') no-repeat right 30px top;
    background-color: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(85, 179, 142, 0.1);
    border-radius: 6px;
    border: 1px solid var(--color-border-1);
    padding: 20px 150px 20px 34px;
    margin-bottom: 50px;
    :deep(.arco-descriptions-item-value-inline) {
      margin-bottom: 20px;
    }
    :deep(.arco-descriptions-item-label-inline) {
      font-size: 13px;
    }
  }
  .failbox {
    height: 136px;
    background: rgba(var(--success-5), 0.06);
    border-radius: 6px;
    padding: 20px;
    display: flex;
  }

  .lt {
    width: auto;
    img {
      width: auto;
      height: 100%;
    }
  }

  .rt {
    flex: 1;
    margin-left: 48px;
    .title {
      color: rgb(var(--primary-6));
      font-weight: 600;
      line-height: 28px;
    }
  }
  .dian {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: rgb(var(--primary-6));
    margin-right: 7px;
    vertical-align: middle;
  }
  ul {
    li {
      color: var(--color-text-2);
      line-height: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .btn {
    width: 92px;
    height: 32px;
    border-radius: 6px;
    font-size: 14px;
    margin-top: 7px;
  }
  :deep(.arco-descriptions-item) {
    vertical-align: top;
  }
}
</style>
